import { removeLocalStorage } from '@helpers/storage'
import { CHECKOUT_DATA } from '@pages/Checkout/constants'
import { Button } from '@ui-kit'
import { useEffect } from 'react'

export const Confirmation = () => {
  useEffect(() => {
    removeLocalStorage(CHECKOUT_DATA)
  }, [])

  const handleConfirmation = () => {
    window.location.reload()
  }

  return (
    <div>
      <h1>Confirmation</h1>

      <Button onClick={handleConfirmation}>Reload Page</Button>
    </div>
  )
}

Confirmation.displayName = 'CheckoutConfirmation'
